export default "__VITE_ASSET__Cznc8sfk__"